<template>
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">{{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }"
                  >Dashboard</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{
                  module
                }}</router-link>
              </li>
              <li class="breadcrumb-item active">Board</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-header bg-warning">
            <h4 class="card-title mb-0 text-white">Menunggu Pembayaran</h4>
          </div>
          <div class="card-body content-board pt-0 px-0" id="infinite-list-menunggu">
            <loading :active.sync="loadingMenungguPembayaran" :height="30" :width="40" color="#398bd7" :is-full-page="false"></loading>
            <ul class="list-group list-group-flush mt-1">
              <li
                class="list-group-item list-group-item-action"
                v-for="(item, index) in dataMenunggu_pembayaran.data" :key="index+'dataMenunggu_pembayaran'"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <router-link :to="{name : 'services_transaction_detail', params : {uuid : item.srv_t_uuid}}">
                    <strong class="mb-0">#{{ item.srv_t_code }}</strong>
                  </router-link>
                  <div class="dropdown">
                    <button
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="btn btn-link dropdown-toggle px-0"
                    >
                      <i class="bx bx-dots-vertical-rounded text-dark"></i>
                    </button>
                    <div
                      aria-labelledby="dropdownMenuButton"
                      class="dropdown-menu dropdown-menu-right"
                      x-placement="bottom-end"
                      style="
                        position: absolute;
                        transform: translate3d(-145px, 36px, 0px);
                        top: 0px;
                        left: 0px;
                        will-change: transform;
                      "
                    >
                      <a href="javascript:;" class="dropdown-item">Edit</a>
                    </div>
                  </div>
                </div>
                <h6 class="list-title mb-0">{{item.usr_fullname}}</h6>
                <p>{{ item.crs_model_name }} - {{ item.cst_crs_police_number }}</p>
                <p>{{ item.srv_t_cat_name }}</p>
                <p>{{ item.srv_t_hours_start }}</p>
                <p>{{ item.srv_t_hours_end }}</p>
                <strong>Rp. {{ $root.numberWithCommas(item.srv_t_estimated_price) }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card">
          <div class="card-header bg-primary">
            <h4 class="card-title mb-0 text-white">Pesanan Diterima</h4>
          </div>
          <div class="card-body content-board pt-0 px-0" id="infinite-list-diterima">
            <loading :active.sync="loadingDiterima" :height="30" :width="40" color="#398bd7" :is-full-page="false"></loading>
            <ul class="list-group list-group-flush mt-1">
              <li
                class="list-group-item list-group-item-action"
                v-for="(item, index) in dataDiterima.data" :key="index+'dataDiterima'"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <router-link :to="{name : 'services_transaction_detail', params : {uuid : item.srv_t_uuid}}">
                    <strong class="mb-0">#{{ item.srv_t_code }}</strong>
                  </router-link>
                  <div class="dropdown">
                    <button
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="btn btn-link dropdown-toggle px-0"
                    >
                      <i class="bx bx-dots-vertical-rounded text-dark"></i>
                    </button>
                    <div
                      aria-labelledby="dropdownMenuButton"
                      class="dropdown-menu dropdown-menu-right"
                      x-placement="bottom-end"
                      style="
                        position: absolute;
                        transform: translate3d(-145px, 36px, 0px);
                        top: 0px;
                        left: 0px;
                        will-change: transform;
                      "
                    >
                      <a href="javascript:;" class="dropdown-item">Edit</a>
                    </div>
                  </div>
                </div>
                <h6 class="list-title mb-0">{{item.usr_fullname}}</h6>
                <p>{{ item.crs_model_name }} - {{ item.cst_crs_police_number }}</p>
                <p>{{ item.srv_t_cat_name }}</p>
                <p>{{ item.srv_t_hours_start }}</p>
                <p>{{ item.srv_t_hours_end }}</p>
                <strong>Rp. {{ $root.numberWithCommas(item.srv_t_estimated_price) }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card">
          <div class="card-header bg-success">
            <h4 class="card-title mb-0 text-white">Pesanan Diproses</h4>
          </div>
          <div class="card-body content-board pt-0 px-0" id="infinite-list-diproses">
            <loading :active.sync="loadingDiProses" :height="30" :width="40" color="#398bd7" :is-full-page="false"></loading>
            <ul class="list-group list-group-flush mt-1">
              <li
                class="list-group-item list-group-item-action"
                v-for="(item, index) in dataDiproses.data" :key="index+'dataDiproses'"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <router-link :to="{name : 'services_transaction_detail', params : {uuid : item.srv_t_uuid}}">
                    <strong class="mb-0">#{{ item.srv_t_code }}</strong>
                  </router-link>
                  <div class="dropdown">
                    <button
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="btn btn-link dropdown-toggle px-0"
                    >
                      <i class="bx bx-dots-vertical-rounded text-dark"></i>
                    </button>
                    <div
                      aria-labelledby="dropdownMenuButton"
                      class="dropdown-menu dropdown-menu-right"
                      x-placement="bottom-end"
                      style="
                        position: absolute;
                        transform: translate3d(-145px, 36px, 0px);
                        top: 0px;
                        left: 0px;
                        will-change: transform;
                      "
                    >
                      <a href="javascript:;" class="dropdown-item">Edit</a>
                    </div>
                  </div>
                </div>
                <h6 class="list-title mb-0">{{item.usr_fullname}}</h6>
                <p>{{ item.crs_model_name }} - {{ item.cst_crs_police_number }}</p>
                <p>{{ item.srv_t_cat_name }}</p>
                <p>{{ item.srv_t_hours_start }}</p>
                <p>{{ item.srv_t_hours_end }}</p>
                <strong>Rp. {{ $root.numberWithCommas(item.srv_t_estimated_price) }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card">
          <div class="card-header bg-secondary">
            <h4 class="card-title mb-0 text-white">Pesanan Selesai</h4>
          </div>
          <div class="card-body content-board pt-0 px-0" id="infinite-list-selesai">
            <loading :active.sync="loadingSelesai" :height="30" :width="40" color="#398bd7" :is-full-page="false"></loading>
            <ul class="list-group list-group-flush mt-1">
              <li
                class="list-group-item list-group-item-action"
                v-for="(item, index) in dataSelesai.data" :key="index+'dataSelesai'"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <router-link :to="{name : 'services_transaction_detail', params : {uuid : item.srv_t_uuid}}">
                    <strong class="mb-0">#{{ item.srv_t_code }}</strong>
                  </router-link>
                  <div class="dropdown">
                    <button
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="btn btn-link dropdown-toggle px-0"
                    >
                      <i class="bx bx-dots-vertical-rounded text-dark"></i>
                    </button>
                    <div
                      aria-labelledby="dropdownMenuButton"
                      class="dropdown-menu dropdown-menu-right"
                      x-placement="bottom-end"
                      style="
                        position: absolute;
                        transform: translate3d(-145px, 36px, 0px);
                        top: 0px;
                        left: 0px;
                        will-change: transform;
                      "
                    >
                      <a href="javascript:;" class="dropdown-item">Edit</a>
                    </div>
                  </div>
                </div>
                <h6 class="list-title mb-0">{{item.usr_fullname}}</h6>
                <p>{{ item.crs_model_name }} - {{ item.cst_crs_police_number }}</p>
                <p>{{ item.srv_t_cat_name }}</p>
                <p>{{ item.srv_t_hours_start }}</p>
                <p>{{ item.srv_t_hours_end }}</p>
                <p><strong>Rp. {{ $root.numberWithCommas(item.srv_t_estimated_price) }}</strong></p>
                <p><strong>Rp. {{ $root.numberWithCommas(item.srv_t_act_price) }}</strong></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card">
          <div class="card-header bg-danger">
            <h4 class="card-title mb-0 text-white">Pesanan Dibatalkan</h4>
          </div>
          <div class="card-body content-board pt-0 px-0" id="infinite-list-dibatalkan">
            <loading :active.sync="loadingDibatalkan" :height="30" :width="40" color="#398bd7" :is-full-page="false"></loading>
            <ul class="list-group list-group-flush mt-1">
              <li
                class="list-group-item list-group-item-action"
                v-for="(item, index) in dataDibatalkan.data" :key="index+'dataDibatalkan'"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <router-link :to="{name : 'services_transaction_detail', params : {uuid : item.srv_t_uuid}}">
                    <strong class="mb-0">#{{ item.srv_t_code }}</strong>
                  </router-link>
                  <div class="dropdown">
                    <button
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="btn btn-link dropdown-toggle px-0"
                    >
                      <i class="bx bx-dots-vertical-rounded text-dark"></i>
                    </button>
                    <div
                      aria-labelledby="dropdownMenuButton"
                      class="dropdown-menu dropdown-menu-right"
                      x-placement="bottom-end"
                      style="
                        position: absolute;
                        transform: translate3d(-145px, 36px, 0px);
                        top: 0px;
                        left: 0px;
                        will-change: transform;
                      "
                    >
                      <a href="javascript:;" class="dropdown-item">Edit</a>
                    </div>
                  </div>
                </div>
                <h6 class="list-title mb-0">{{item.usr_fullname}}</h6>
                <p>{{ item.crs_model_name }} - {{ item.cst_crs_police_number }}</p>
                <p>{{ item.srv_t_cat_name }}</p>
                <p>{{ item.srv_t_hours_start }}</p>
                <p>{{ item.srv_t_hours_end }}</p>
                <strong>Rp. {{ $root.numberWithCommas(item.srv_t_estimated_price) }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      module: "Transaksi Servis",
      table_module: "services_transaction",
      alias_table: "srv_t",
      dataDibatalkan: [],
      dataDiproses: [],
      dataDiterima: [],
      dataMenunggu_pembayaran: [],
      dataSelesai: [],
      loadingDibatalkan: false,
      loadingSelesai: false,
      loadingDiProses: false,
      loadingDiterima: false,
      loadingMenungguPembayaran: false,
      page_dibatalkan : 1,
      page_selesai : 1,
      page_diproses : 1,
      page_diterima : 1,
      page_menunggu_pembayaran : 1,
    };
  },
  mounted() {
    let that = this;
    // Detect when scrolled to bottom.
    const listElm = document.querySelector('#infinite-list-dibatalkan');
    if (listElm != null) 
    {
      listElm.addEventListener('scroll', function(){
        if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          that.loadMoreDibatalkan();
        }
      });
    }

    const listElmSelesai = document.querySelector('#infinite-list-selesai');
    if (listElmSelesai != null) 
    {
      listElmSelesai.addEventListener('scroll', function(){
        if(listElmSelesai.scrollTop + listElmSelesai.clientHeight >= listElmSelesai.scrollHeight) {
          that.loadMoreSelesai();
        }
      });      
    }

    const listElmDiproses = document.querySelector('#infinite-list-diproses');
    if (listElmDiproses != null) 
    {
      listElmDiproses.addEventListener('scroll', function(){
        if(listElmDiproses.scrollTop + listElmDiproses.clientHeight >= listElmDiproses.scrollHeight) {
          that.loadMoreDiproses();
        }
      });
    }

    const listElmDiterima = document.querySelector('#infinite-list-diterima');

    if (listElmDiterima != null) 
    {
      listElmDiterima.addEventListener('scroll', function(){
        if(listElmDiterima.scrollTop + listElmDiterima.clientHeight >= listElmDiterima.scrollHeight) {
          that.loadMoreDiterima();
        }
      });      
    }

    this.fetchData();
  },
  methods: {
    fetchData: function () {
      this.axios.post("/services_transaction/board").then((response) => {
        this.dataDibatalkan = response.data.data.dibatalkan;
        this.dataDiproses = response.data.data.diproses;
        this.dataDiterima = response.data.data.diterima;
        this.dataMenunggu_pembayaran = response.data.data.menunggu_pembayaran;
        this.dataSelesai = response.data.data.selesai;
      });
    },
    loadMoreDibatalkan: function() {
      if(this.dataDibatalkan.total_page <= this.page_dibatalkan)
      {
        return false;
      }

      this.loadingDibatalkan = true;
      setTimeout(() => {
        this.loadingDibatalkan = false;
        this.axios.post("/services_transaction/board_single", { status_id : 9, page : this.page_dibatalkan + 1}).then((response) => {
          this.page_dibatalkan = response.data.data.current_page;
          let data = response.data.data.data;
          data.forEach(element=> {
            this.dataDibatalkan.data.push(element)
          });
        });
      }, 1000);
    },
    loadMoreSelesai: function() {
      if(this.dataSelesai.total_page <= this.page_selesai)
      {
        return false;
      }

      this.loadingSelesai = true;
      setTimeout(() => {
        this.loadingSelesai = false;
        this.axios.post("/services_transaction/board_single", { status_id : 1, page : this.page_selesai + 1}).then((response) => {
          this.page_selesai = response.data.data.current_page;
          let data = response.data.data.data;
          data.forEach(element=> {
            this.dataSelesai.data.push(element)
          });
        });
      }, 1000);
    },
    loadMoreDiproses: function() {
      if(this.dataDiproses.total_page <= this.page_diproses)
      {
        return false;
      }

      this.loadingDiProses = true;
      setTimeout(() => {
        this.loadingDiProses = false;
        this.axios.post("/services_transaction/board_single", { status_id : 2, page : this.page_diproses + 1}).then((response) => {
          this.page_diproses = response.data.data.current_page;
          let data = response.data.data.data;
          data.forEach(element=> {
            this.dataDiproses.data.push(element)
          });
        });
      }, 1000);
    },
    loadMoreDiterima: function() {
      if(this.dataDiterima.total_page <= this.page_diterima)
      {
        return false;
      }

      this.loadingDiterima = true;
      setTimeout(() => {
        this.loadingDiterima = false;
        this.axios.post("/services_transaction/board_single", { status_id : 3, page : this.page_diterima + 1}).then((response) => {
          this.page_diterima = response.data.data.current_page;
          let data = response.data.data.data;
          data.forEach(element=> {
            this.dataDiterima.data.push(element)
          });
        });
      }, 1000);
    },
    loadMoreMenunggu: function() {
      if(this.dataMenunggu_pembayaran.total_page <= this.page_menunggu_pembayaran)
      {
        return false;
      }

      this.loadingMenungguPembayaran = true;
      setTimeout(() => {
        this.loadingMenungguPembayaran = false;
        this.axios.post("/services_transaction/board_single", { status_id : 0, page : this.page_menunggu_pembayaran + 1}).then((response) => {
          this.page_menunggu_pembayaran = response.data.data.current_page;
          let data = response.data.data.data;
          data.forEach(element=> {
            this.dataMenunggu_pembayaran.data.push(element)
          });
        });
      }, 1000);
    },
  },
};
</script>

<style scoped>
.card-body.content-board {
  max-height: 600px;
  overflow-y: auto;
}
</style>